import {
  AccountSettings,
  AccountSettingsOverview,
  PaymentAndBanking,
  PaymentMethod,
  BankAccounts,
  Providers,
  PersonalInformation,
  Communications,
  ReleaseAuthorizations,
} from '@/pages';
import { RouteConfig } from 'vue-router';

export const accountSettingsRoutes: RouteConfig = {
  name: 'accountSettings',
  path: '/account-settings',
  component: AccountSettings,
  redirect: { name: 'accountSettingsOverview' },
  meta: {
    subtitle: false,
    title: ['account-settings_page-title', 'global_account-plan-settings'],
  },
  children: [
    {
      name: 'accountSettingsOverview',
      path: 'overview',
      component: AccountSettingsOverview,
    },
    {
      name: 'paymentAndBanking',
      path: 'payment-and-banking',
      component: PaymentAndBanking,
      meta: {
        subtitle: true,
        title: ['payment-banking_page-title', 'global_payment-banking'],
      },
      children: [
        {
          name: 'paymentMethod',
          path: 'payment-method',
          component: PaymentMethod,
        },
        {
          name: 'bankAccounts',
          path: 'bank-accounts',
          component: BankAccounts,
        },
      ],
    },
    {
      name: 'providers',
      path: 'providers',
      component: Providers,
      meta: {
        subtitle: true,
        title: ['providers_page-title', 'global_providers'],
      },
    },
    {
      name: 'communications',
      path: 'communications',
      component: Communications,
      meta: {
        subtitle: true,
        title: 'communications_page-title',
      },
    },
    {
      name: 'personalInformation',
      path: 'personal-information',
      component: PersonalInformation,
      meta: {
        subtitle: true,
        title: [
          'personal-information_page-title',
          'global_personal-information',
        ],
      },
    },
    {
      name: 'releaseAuthorizations',
      path: 'release-authorizations',
      component: ReleaseAuthorizations,
      meta: {
        subtitle: true,
        title: ['ari_page-title', 'global_release-authorization'],
      },
    },
  ],
};
